<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LkIwhR/tc-custom/9781467464796.jpg?1731796565104" alt="This image is the cover for the book Paul"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Paul
      </h1>
      <p class="bookDescription body article font2">
        <p>Now back in print in a beautiful new paperback edition, this study by one of Europe's foremost New Testament scholars provides a comprehensive exposition of the teaching of the apostle Paul.<br/><br/> Firmly grounded in a careful exegesis of the biblical text and crafted with constant reference to the wealth of scholarly study of Paul's writings, this volume is a standard for interpreters of Paul's thought and all students of the New Testament.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Herman Ridderbos
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Herman Ridderbos</B>&#160;(1909&ndash;2007) was professor of New Testament at the Theological School of the Reformed Churches of the Netherlands in Kampen.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?001df405